import { call, put, takeLatest } from "redux-saga/effects";
import { AxiosResponse } from "axios";
import { getCourseViewTemplateData, getCourseCountData, getCourseInstanceViewTemplateData, deleteCourseTemplate, deleteCourseInstance } from "./view-course-template.service";
import { GET_COURSE_VIEW_TEMPLATE, GET_CARD_COURSE_COUNT, setCourseViewTemplate, setCardCourseCount, GET_COURSE_INSTANCE_VIEW_TEMPLATE, setCourseInstanceViewTemplate, DELETE_COURSE_TEMPLATE, setDeleteCourseTemplate, DELETE_COURSE_INSTANCE, setDeleteCourseInstance } from "./view-course-template.action";
import { hideLoader, showLoader, showToast } from "../../store/model/model.action";
import { SagaIterator } from "redux-saga";


export default function* ViewCourseTemplateSaga() {
  yield takeLatest(GET_COURSE_VIEW_TEMPLATE, handleCourseViewTemplate);
  yield takeLatest(GET_CARD_COURSE_COUNT, handlecardCourseCount);
  yield takeLatest(GET_COURSE_INSTANCE_VIEW_TEMPLATE, handleCourseInstanceViewTemplate);
  yield takeLatest(DELETE_COURSE_TEMPLATE, handleDeleteCourseTemplate);
  yield takeLatest(DELETE_COURSE_INSTANCE, handleDeleteCourseInstance);

}

export function* handleCourseViewTemplate(requestParams: any): SagaIterator {
  try {
    yield put(showLoader());
    const resultData: any = yield call(getCourseViewTemplateData, requestParams.payload);
    yield put(hideLoader());
    if (resultData.success) {
      if(requestParams.payload.prevData && requestParams.payload.prevData.length > 0){
        yield put(setCourseViewTemplate([...requestParams.payload.prevData, ...resultData.data]));
      } else {
        yield put(setCourseViewTemplate(resultData.data));
      }
    } else {
      yield put(setCourseViewTemplate([]));
      yield put(showToast({ type: 'error', content: "Failed to load data" }));
    }
  } catch (error) {
    yield put(hideLoader());
    yield put(setCourseViewTemplate([]));
  }
}

export function* handlecardCourseCount(requestParam: any): SagaIterator {
  try {
    const resultData: any = yield call(
      getCourseCountData,
      requestParam
    );
    if(resultData.success) {
      yield put(setCardCourseCount(resultData.data));
    } else{
      yield put(setCardCourseCount([]))
    }
  } catch (error) { }
}

export function* handleCourseInstanceViewTemplate (requestParam: any): SagaIterator {
  try {
    yield put(showLoader())
    const resultData: any = yield call(
      getCourseInstanceViewTemplateData,
      requestParam.payload
    );
    yield put(hideLoader());
    if (resultData.success) {
      if (requestParam.payload.prevData && requestParam.payload.prevData.length > 0) {
        yield put(setCourseInstanceViewTemplate({
          courseInstanceData: [...requestParam.payload.prevData, ...resultData.data?.courseInstanceData]
        }));
      } else {
        yield put(setCourseInstanceViewTemplate(resultData.data));
      }
    } else {
      yield put(setCourseInstanceViewTemplate([]));
      yield put(showToast({ type: 'error', content: "Failed to load data" }));
    }
  } catch (error) {
    yield put(hideLoader());
    yield put(setCourseInstanceViewTemplate([]));
   }
}

export const handleDeleteCourseTemplate = function* (requestParam: {
  type: string;
  payload: string;
}) {
  try {
    yield put(showLoader())
    const resultData: AxiosResponse<any> = yield call(
      deleteCourseTemplate,
      requestParam.payload
    );
    yield put(hideLoader());
    yield put(setDeleteCourseTemplate(resultData));
  } catch (error) {
    yield put(hideLoader());
  }
}
export const handleDeleteCourseInstance = function* (requestParam: {
  type: string;
  payload: string;
}) {
  try {
    yield put(showLoader())
    const resultData: AxiosResponse<any> = yield call(
      deleteCourseInstance,
      requestParam.payload
    );
    yield put(hideLoader());
    yield put(setDeleteCourseInstance(resultData));
  } catch (error) {
    yield put(hideLoader());
  }
}
